export default "<div class=\"loader-container\">\n  <div class=\"lds-dual-ring\"></div>\n</div>";